import React from "react";
import { T } from "services/lang/LanguageService";
import { DatasetStringValueMapperDTO } from "../../../charts/interfaces";

const MapperMappings = ({ selectedMapper }: { selectedMapper: DatasetStringValueMapperDTO }) => {
  return (
    <div>
      {selectedMapper.mappers.length === 0 ? (
        <h3>{T("word.no-mappings")}</h3>
      ) : (
        <ul>
          {selectedMapper.mappers.map(m => (
            <li key={m.id}>
              {m.key}: {m.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MapperMappings;
